import { ValidatorModel } from "../models";

/**
 * * Класс для создания валидаторов формы
 */
export class FormValidators {
  /**
   * * Валидатор email
   * @param errorMessage Сообщение об ошибке
   * @returns
   */
  static email(errorMessage: string) {
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
    return new ValidatorModel<string | undefined>({
      GetErrorMessage: () => errorMessage,
      ValidationFn: (value) => !!value && regex.test(value),
    });
  }

  /**
   * * Валидатор суммы
   * @param errorMessage Сообщение об ошибке
   * @returns
   */
  static amount(errorMessage: string) {
    return new ValidatorModel<string | number | undefined>({
      GetErrorMessage: () => errorMessage,
      ValidationFn: (value) => value != undefined && Number(value) > 0,
    });
  }

  /**
   * * Валидатор ссылки
   * @param errorMessage Сообщение об ошибке
   * @returns
   */
  static linkValidator(errorMessage: string) {
    return new ValidatorModel<string | undefined>({
      GetErrorMessage: () => errorMessage,
      ValidationFn: (value) => {
        if (!value) return false;
        const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&amp;=]*)?$/;
        return regex.test(value);
      },
    });
  }

  /**
   * * Валидатор ссылки
   * @param errorMessage Сообщение об ошибке
   * @returns
   */
  static minArrayLength(
    minLength: number,
    errorMessage: string | ((length: number) => string)
  ) {
    return new ValidatorModel<Array<any> | undefined>({
      GetErrorMessage: (value) => {
        return typeof errorMessage === "function"
          ? errorMessage((value || "").toString().trim().length)
          : errorMessage;
      },
      ValidationFn: (value) => {
        return !!value?.length && value.length >= minLength;
      },
    });
  }

  /**
   * * Валидатор ссылки
   * @param errorMessage Сообщение об ошибке
   * @returns
   */
  static minLength(
    minLength: number,
    errorMessage: string | ((length: number) => string)
  ) {
    return new ValidatorModel<string | undefined>({
      GetErrorMessage: (value) => {
        return typeof errorMessage === "function"
          ? errorMessage((value || "").toString().trim().length)
          : errorMessage;
      },
      ValidationFn: (value) => {
        return !!value && value.toString()?.trim()?.length >= minLength;
      },
    });
  }

  /**
   * * Валидатор обязательного значения
   * @param errorMessage Сообщение об ошибке
   * @param acceptZero Разрешено нулевое значение
   * @returns
   */
  static required<T extends number | undefined | string | boolean | object>(
    errorMessage: string,
    acceptZero?: boolean
  ) {
    return new ValidatorModel<T>({
      GetErrorMessage: () => errorMessage,
      ValidationFn: (value) => {
        switch (typeof value) {
          case "string":
            return !!value.trim();
          case "number":
            return acceptZero ? !!value || value === 0 : !!value;
          default:
            return !!value;
        }
      },
    });
  }

  /**
   * * Валидатор минимальной даты
   * @param errorMessage Сообщение об ошибке
   * @param minDate Миинимальная дата
   * @returns
   */
  static minDate(errorMessage: string, minDate: Date) {
    return new ValidatorModel<Date>({
      GetErrorMessage: () => errorMessage,
      ValidationFn: (value) => {
        return value && value.getTime() > minDate.getTime();
      },
    });
  }
  /**
   * * Валидатор максимальной даты
   * @param errorMessage Сообщение об ошибке
   * @param maxDate Максимальная дата
   * @returns
   */
  static maxDate(errorMessage: string, maxDate: Date) {
    return new ValidatorModel<Date>({
      GetErrorMessage: () => errorMessage,
      ValidationFn: (value) => {
        return value && value.getTime() < maxDate.getTime();
      },
    });
  }
}
